export default __webpack_public_path__ + "favicon-3afa2080213e06d014e20c67710f2977.png";